import type { FC } from 'react';
import type { Showable } from 'utils/hooks/useShowable';
import { CustomPortSettingsDialog } from './CustomPortSettingsDialog';
import type { CustomPortSetting } from './model';
import type { CustomPortSettingsCommands } from './useCustomPortSettings';

type Props = {
  commands: CustomPortSettingsCommands;
  showable: Showable;
};

const initialValues: CustomPortSetting = {
  excludeSubnets: [],
  label: '',
  port: 22,
  protocol: 'ssh',
  subnets: [],
};

export const AddSettingDialog: FC<Props> = (props) => {
  if (!props.showable.shown) {
    return null;
  }

  const { showable } = props;

  return (
    <CustomPortSettingsDialog
      initialValues={initialValues}
      onClose={showable.hide}
      onSubmit={(setting: CustomPortSetting) => {
        props.commands.addSetting({ setting });
      }}
      type='add'
    />
  );
};
